import axios from 'axios'
import { baseUrl } from './config'

export function startCrash () {
  return axios.post(`${baseUrl}/crash-game/start`)
}

export function stopCrash () {
  return axios.post(`${baseUrl}/crash-game/stop`)
}

export function getCrashDelay () {
  return axios.get(`${baseUrl}/crash-game/delay`)
}

export function updCrashDelay (params) {
  return axios.post(`${baseUrl}/crash-game/delay`, params)
}

export function getCrashGeneralStats () {
  return axios.get(`${baseUrl}/crash-game/statistics/general`)
}

export function getCrashRoundsStats (params) {
  return axios.get(`${baseUrl}/crash-game/statistics/rounds`, {
    params
  })
}

export function getCrashBetsStats (params) {
  return axios.get(`${baseUrl}/crash-game/statistics/bets`, {
    params
  })
}
